// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconPermalinkPath = 'M5.944 1.319A3.385 3.385 0 0 1 10.69.704a3.382 3.382 0 0 1 .604 4.739l-.54.719-1.6-1.201.55-.731a1.383 1.383 0 0 0-.238-1.944 1.379 1.379 0 0 0-1.932.246l-1.96 2.61a1.391 1.391 0 0 0-.096 1.572L3.897 7.948a3.396 3.396 0 0 1 .086-4.018l1.96-2.611Zm.578 3.965L8.103 4.05a3.398 3.398 0 0 1-.086 4.019l-1.961 2.61a3.392 3.392 0 0 1-2.687 1.319c-.722 0-1.447-.23-2.06-.704a3.382 3.382 0 0 1-.604-4.74l.541-.718 1.6 1.2-.55.732a1.378 1.378 0 1 0 2.17 1.698l1.96-2.61c.356-.46.391-1.087.096-1.572Z';
var ActionIconPermalink = baseIcon('ActionIconPermalink', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconPermalinkPath
});
export default ActionIconPermalink;
//# sourceMappingURL=index.js.map